var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgLbAvatarIcon = props => /*#__PURE__*/React.createElement("svg", _extends({
  preserveAspectRatio: "none",
  overflow: "visible",
  style: {
    display: "block"
  },
  viewBox: "0 0 24.452 28",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
  id: "Icon",
  opacity: 0.15
}, /*#__PURE__*/React.createElement("path", {
  d: "M23.476 28C24.0283 28 24.4794 27.5495 24.4507 26.998C24.121 20.666 20.548 17.5 12.226 17.5C3.90394 17.5 0.330908 20.666 0.00129874 26.998C-0.0274113 27.5495 0.42369 28 0.975975 28H23.476Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M12.226 12.25C15.726 12.25 17.476 10.5 17.476 6.125C17.476 1.75 15.726 0 12.226 0C8.72598 0 6.97598 1.75 6.97598 6.125C6.97598 10.5 8.72598 12.25 12.226 12.25Z",
  fill: "white"
}))));
export default SvgLbAvatarIcon;